import { useStore } from '@/store/useStore';
import { normalizeGlsLaunchProvider } from '@/api/gls/normalize-gls-launch-provider';

/** Game metadata from the first GLS response / aggregation, used to skip Prismic on reconcile. */
export type GlsCachedGameDetails = {
  gameUid: string;
  provider: string;
  providerRef: string;
  directLaunchParams?: Record<string, unknown>;
};

/**
 * Reads provider identity already resolved for the current launch (first GLS +
 * aggregation). Same fields game-client sends on a direct (non-Prismic) init.
 * Jackpot reconcile clears {@link GamePayload} delivery state only; `gameContext`
 * (including these fields) is intentionally preserved.
 */
export const getGlsCachedGameDetailsFromStore =
  (): GlsCachedGameDetails | null => {
    const { gameUid, provider, glsLaunchProvider, providerRef, directLaunchParams } =
      useStore.getState().gameContext;

    const providerForLaunch = normalizeGlsLaunchProvider(
      (glsLaunchProvider ?? provider ?? '').trim(),
    );

    if (!gameUid?.trim() || !providerForLaunch || !providerRef?.trim()) {
      return null;
    }

    return {
      gameUid,
      provider: providerForLaunch,
      providerRef,
      ...(directLaunchParams ? { directLaunchParams } : {}),
    };
  };
